module.exports = __webpack_public_path__ + "static/media/16x20no1.c5727e70.jpg";